import { UnitTypeGrid } from './unit-type.grid';
import { PropertyGridComponent } from './property.grid';
import { PropertyMapGridComponent } from './property.map-grid';
import { PropertyNameRendererComponent } from './property-name-renderer.component';
import { PropertyImageCellComponent } from './property-image-cell.component';

export const GRID_COMPONENTS = [
  UnitTypeGrid,
  PropertyGridComponent,
  PropertyNameRendererComponent,
  PropertyMapGridComponent,
  PropertyImageCellComponent
];

export {
  UnitTypeGrid,
  PropertyGridComponent,
  PropertyNameRendererComponent,
  PropertyMapGridComponent,
  PropertyImageCellComponent
};



// WEBPACK FOOTER //
// ./src/app/features/property/components/grids/index.ts